import styled, { css } from 'styled-components';
import { assetPath } from '../../../utils/web-helper';
import ElaSprite from '~images/onboarding/splashverse-onboarding-ela.png';
import ElaSpriteV2 from '~images/onboarding/splashverse-onboarding-ela-v2.png';
import MathSprite from '~images/onboarding/splashverse-onboarding-math.png';
import MathSpriteV2 from '~images/onboarding/splashverse-onboarding-math-v2.png';
import { device } from '../../../utils/responsive_utilities';

export const SkillInfoWrapper = styled.div`
  @media ${device.PhoneTabletLandscape}{
    order: ${props => props.buildLearningPath ? 2 : 1};
    flex-basis: ${props => props.buildLearningPath ? '34%' : '80%'};
  }
`
export const Thumbnails = styled.span`
  ${props => {
    if(props.isNewCoqAbTest) {
      return css`
        background: url(${props => assetPath(props.subject === 'ela' ? ElaSpriteV2 : MathSpriteV2)});
        transform: ${props => props.subject === 'ela' ? 'scale(1)' : 'scale(1.6)'};

        &.grade-pk {
          &.subj-math {
            &.num-seq {
              background-position: 0 -1.6rem;
            }
            &.shapes {
              background-position: -2.2rem -1.6rem;
            }
            &.count-comp {
              background-position: -4.4rem -1.6rem;
            }
            &.add {
              background-position: -6.6rem -1.6rem;
            }
            &.sub {
              background-position: -8.8rem -1.6rem;
            }
            &.measure {
              background-position: -11rem -1.6rem;
            }
            &.num-reco {
              background-position: -13.2rem -1.6rem;
            }
            &.num-trace {
              background-position: -15.4rem -1.6rem;
            }
          }
          &.subj-ela {
            &.age-2 {
              &.coq_ela_pk_2_q1.as {
                background-position: -1.2rem -4rem;
              }
              &.coq_ela_pk_2_q2.ucls {
                background-position: -5.2rem -4rem;
              }
              &.coq_ela_pk_2_q3.ucls {
                background-position: -9.2rem -4rem;
              }
              &.coq_ela_pk_2_q4.uctr {
                background-position: -13.2rem -4rem;
              }
              &.coq_ela_pk_2_q5.br {
                background-position: -17rem -4rem;
              }
              &.coq_ela_pk_2_q6.sw {
                background-position: -21rem -4rem;
              }
              &.coq_ela_pk_2_q7.se {
                background-position: -25rem -4rem;
              }
              &.coq_ela_pk_2_q8.ucls {
                background-position: -28.7rem -4rem;
              }
            }
            &.age-3 {
              &.coq_ela_pk_3_q1.as {
                background-position: -1.2rem -10.6rem;
              }
              &.coq_ela_pk_3_q2.ucls {
                background-position: -5.2rem -10.6rem;
              }
              &.coq_ela_pk_3_q3.ucls {
                background-position: -9.2rem -10.6rem;
              }
              &.coq_ela_pk_3_q4.uctr {
                background-position: -13.2rem -10.6rem;
              }
              &.coq_ela_pk_3_q5.lcls {
                background-position: -17rem -10.6rem;
              }
              &.coq_ela_pk_3_q6.lctr {
                background-position: -21rem -10.6rem;
              }
              &.coq_ela_pk_3_q7.br {
                background-position: -25rem -10.6rem;
              }
              &.coq_ela_pk_3_q8.sw {
                background-position: -28.7rem -10.6rem;
              }
            }
            &.age-4 {
              &.coq_ela_pk_4_q1.as {
                background-position: -1.2rem -17.2rem;
              }
              &.coq_ela_pk_4_q2.ucls {
                background-position: -5.2rem -17.2rem;
              }
              &.coq_ela_pk_4_q3.ucls {
                background-position: -9.2rem -17.2rem;
              }
              &.coq_ela_pk_4_q4.uctr {
                background-position: -13.2rem -17.2rem;
              }
              &.coq_ela_pk_4_q5.sw {
                background-position: -17rem -17.2rem;
              }
              &.coq_ela_pk_4_q6.lcls {
                background-position: -21rem -17.2rem;
              }
              &.coq_ela_pk_4_q7.lctr {
                background-position: -25rem -17.2rem;
              }
              &.coq_ela_pk_4_q8.br {
                background-position: -28.7rem -17.2rem;
              }
            }
          }
        }
        &.grade-k {
          &.subj-math {
            &.count-comp {
              background-position: 0 -5.4rem;
            }
            &.add-sub-facts {
              background-position: -2.2rem -5.4rem;
            }
            &.place-value-ns {
              background-position: -4.4rem -5.4rem;
            }
            &.measurement-data {
              background-position: -6.6rem -5.4rem;
            }
            &.geometry {
              background-position: -8.8rem -5.4rem;
            }
            &.num-seq {
              background-position: -11rem -5.4rem;
            }
            &.add {
              background-position: -13.2rem -5.4rem;
            }
            &.sub {
              background-position: -15.4rem -5.4rem;
            }
            &.num-trace {
              background-position: -17.6rem -5.4rem;
            }
          }
          &.subj-ela {
            &.coq_ela_k_5_q1.az {
              background-position: -1.2rem -23.8rem;
            }
            &.coq_ela_k_5_q2.rw {
              background-position: -5.2rem -23.8rem;
            }
            &.coq_ela_k_5_q3.lctr {
              background-position: -9.2rem -23.8rem;
            }
            &.coq_ela_k_5_q4.br {
              background-position: -13.2rem -23.8rem;
            }
            &.coq_ela_k_5_q5.sw {
              background-position: -17rem -23.8rem;
            }
            &.coq_ela_k_5_q6.sp {
              background-position: -21rem -23.8rem;
            }
            &.coq_ela_k_5_q7.se {
              background-position: -25rem -23.8rem;
            }
            &.coq_ela_k_5_q8.az {
              background-position: -28.7rem -23.8rem;
            }
          }
        }
        &.grade-1 {
          &.subj-math {
            &.add-sub-facts {
              background-position: 0 -9.2rem;
            }
            &.place-value-ns {
              background-position: -2.2rem -9.2rem;
            }
            &.add-sub-pv {
              background-position: -4.4rem -9.2rem;
            }
            &.time-money {
              background-position: -6.6rem -9.2rem;
            }
            &.measurement-data {
              background-position: -8.8rem -9.2rem;
            }
            &.geometry {
              background-position: -11rem -9.2rem;
            }
            &.rec-add-sub-facts {
              background-position: -13.2rem -9.2rem;
            }
            &.add-w20 {
              background-position: -15.2rem -9.2rem;
            }
            &.sub-w20 {
              background-position: -17.4rem -9.2rem;
            }
            &.add-pv {
              background-position: -19.6rem -9.2rem;
            }
            &.sub-pv {
              background-position: -21.8rem -9.2rem;
            }
            &.time {
              background-position: -24rem -9.2rem;
            }
            &.money {
              background-position: -26.2rem -9.2rem;
            }
          }
          &.subj-ela {
            &.coq_ela_1_q1.rw {
              background-position: -1.2rem -30.4rem;
            }
            &.coq_ela_1_q2.rw {
              background-position: -5.2rem -30.4rem;
            }
            &.coq_ela_1_q3.rw {
              background-position: -9.2rem -30.4rem;
            }
            &.coq_ela_1_q4.br {
              background-position: -13.2rem -30.4rem;
            }
            &.coq_ela_1_q5.sw {
              background-position: -17rem -30.4rem;
            }
            &.coq_ela_1_q6.sp {
              background-position: -21rem -30.4rem;
            }
            &.coq_ela_1_q7.rw {
              background-position: -25rem -30.4rem;
            }
            &.coq_ela_1_q8.rw {
              background-position: -28.7rem -30.4rem;
            }
          }
        }
        &.grade-2 {
          &.subj-math {
            &.add-sub-facts {
              background-position: 0 -13.2rem;
            }
            &.place-value-ns {
              background-position: -2.2rem -13.2rem;
            }
            &.add-sub-pv-2 {
              background-position: -4.4rem -13.2rem;
            }
            &.time-money {
              background-position: -6.6rem -13.2rem;
            }
            &.measurement-data {
              background-position: -8.8rem -13.2rem;
            }
            &.geometry {
              background-position: -11rem -13.2rem;
            }
            &.add-w20 {
              background-position: -13.2rem -13.2rem;
            }
            &.sub-w20 {
              background-position: -15.4rem -13.2rem;
            }
            &.add-pv2 {
              background-position: -17.6rem -13.2rem;
            }
            &.money {
              background-position: -19.8rem -13.2rem;
            }
            &.time {
              background-position: -22rem -13.2rem;
            }
          }
          &.subj-ela {
            &.coq_ela_2_q1.rw {
              background-position: -1.2rem -37rem;
            }
            &.coq_ela_2_q2.rw {
              background-position: -5.2rem -37rem;
            }
            &.coq_ela_2_q3.rw {
              background-position: -9.2rem -37rem;
            }
            &.coq_ela_2_q4.br {
              background-position: -13.2rem -37rem;
            }
            &.coq_ela_2_q5.sw {
              background-position: -17rem -37rem;
            }
            &.coq_ela_2_q6.sp {
              background-position: -21rem -37rem;
            }
            &.coq_ela_2_q7.rw {
              background-position: -25rem -37rem;
            }
            &.coq_ela_2_q8.rw {
              background-position: -28.7rem -37rem;
            }
            &.coq_ela_2_q9.rw {
              background-position: -32.7rem -37rem;
            }
          }
        }
        &.grade-3 {
          &.subj-math {
            &.place-value-ns {
              background-position: 0 -17rem;
            }
            &.add-sub-pv-3 {
              background-position: -2.2rem -17rem;
            }
            &.mult-div-facts {
              background-position: -4.4rem -17rem;
            }
            &.fractions {
              background-position: -6.6rem -17rem;
            }
            &.time-money {
              background-position: -8.8rem -17rem;
            }
            &.measurement-data {
              background-position: -11rem -17rem;
            }
            &.geometry {
              background-position: -13.2rem -17rem;
            }
            &.mult-div-pv-2 {
              background-position: -15.4rem -17rem;
            }
            &.add-pv-3 {
              background-position: -17.6rem -17rem;
            }
            &.mult-facts {
              background-position: -19.8rem -17rem;
            }
            &.div-facts {
              background-position: -22rem -17rem;
            }
            &.time {
              background-position: -24.2rem -17rem;
            }
            &.mult-pv-2 {
              background-position: -26.4rem -17rem;
            }
          }
        }
        &.grade-4 {
          &.subj-math {
            &.place-value-ns {
              background-position: 0 -21rem;
            }
            &.algebra {
              background-position: -2.2rem -21rem;
            }
            &.add-sub-pv-4 {
              background-position: -4.4rem -21rem;
            }
            &.mult-div-pv {
              background-position: -6.6rem -21rem;
            }
            &.fractions {
              background-position: -8.8rem -21rem;
            }
            &.decimals {
              background-position: -11rem -21rem;
            }
            &.measurement-data {
              background-position: -13.2rem -21rem;
            }
            &.geometry {
              background-position: -15.4rem -21rem;
            }
            &.mul-pv {
              background-position: -17.6rem -21rem;
            }
            &.div-pv {
              background-position: -19.8rem -21rem;
            }
          }
        }
        &.grade-5 {
          &.subj-math {
            &.decimals {
              background-position: 0 -24.8rem;
            }
            &.algebra {
              background-position: -2.2rem -24.8rem;
            }
            &.mult-div {
              background-position: -4.4rem -24.8rem;
            }
            &.fractions {
              background-position: -6.6rem -24.8rem;
            }
            &.decimal-arith {
              background-position: -8.8rem -24.8rem;
            }
            &.measurement-data {
              background-position: -11rem -24.8rem;
            }
            &.geometry {
              background-position: -13.2rem -24.8rem;
            }
            &.mul-pv {
              background-position: -15.4rem -24.8rem;
            }
            &.div-pv {
              background-position: -17.6rem -24.8rem;
            }
          }
        }
      `;
    } else {
      return css`
        background: url(${props => assetPath(props.subject === 'ela' ? ElaSprite : MathSprite)});
        &.grade-pk {
          &.subj-math {
            &.num-seq {
              background-position: -1.2rem -4.3rem;
            }
            &.shapes {
              background-position: -4.7rem -4.3rem;
            }
            &.count {
              background-position: -8rem -4.3rem;
            }
            &.add {
              background-position: -11.5rem -4.3rem;
            }
            &.sub {
              background-position: -14.8rem -4.3rem;
            }
            &.measure {
              background-position: -18.3rem -4.3rem;
            }
            &.num-reco {
              background-position: -21.7rem -4.3rem;
            }
            &.num-trace {
              background-position: -25.1rem -4.3rem;
            }
          }
          &.subj-ela {
            &.se {
              background-position: -2.6rem -3.7rem;
            }
            &.ls {
              background-position: -6.2rem -3.7rem;
            }
            &.tr {
              background-position: -9.7rem -3.7rem;
            }
            &.sw {
              background-position: -13.3rem -3.7rem;
            }
            &.az {
              background-position: -16.9rem -3.7rem;
            }
            &.lr {
              background-position: -20.4rem -3.7rem;
            }
          }
        }
        &.grade-k {
          &.subj-math {
            &.count-comp {
              background-position: -1.1rem -11.6rem;
            }
            &.add-sub-facts {
              background-position: -4.5rem -11.6rem;
            }
            &.place-value-ns {
              background-position: -7.9rem -11.6rem;
            }
            &.measurement-data {
              background-position: -11.4rem -11.6rem;
            }
            &.geometry {
              background-position: -14.7rem -11.6rem;
            }
          }
          &.subj-ela {
            &.lr {
              background-position: -2.8rem -11.0rem;
            }
            &.db {
              background-position: -6.3rem -11.0rem;
            }
            &.rw {
              background-position: -9.9rem -11.1rem;
            }
            &.az {
              background-position: -13.5rem -11.0rem;
            }
            &.sw {
              background-position: -16.9rem -11.2rem;
            }
          }
        }
        &.grade-1 {
          &.subj-math {
            &.add-sub-facts {
              background-position: -1.1rem -18.6rem;
            }
            &.place-value-ns {
              background-position: -4.5rem -18.6rem;
            }
            &.add-sub-pv {
              background-position: -7.9rem -18.6rem;
            }
            &.time-money {
              background-position: -11.3rem -18.6rem;
            }
            &.measurement-data {
              background-position: -14.7rem -18.6rem;
            }
            &.geometry {
              background-position: -18.1rem -18.6rem;
            }
            &.rec-add-sub-facts {
              background-position: -21.5rem -18.6rem;
            }
          }
          &.subj-ela {
            &.lr {
              background-position: -1.7rem -18.6rem;
            }
            &.db {
              background-position: -5.3rem -18.6rem;
            }
            &.rw {
              background-position: -8.7rem -18.7rem;
            }
            &.sw {
              background-position: -12.3rem -18.6rem;
            }
          }
        }
        &.grade-2 {
          &.subj-math {
            &.add-sub-facts {
              background-position: -0.9rem -26.3rem;
            }
            &.place-value-ns {
              background-position: -4.3rem -26.3rem;
            }
            &.add-sub-pv-2 {
              background-position: -7.7rem -26.3rem;
            }
            &.time-money {
              background-position: -11.1rem -26.3rem;
            }
            &.measurement-data {
              background-position: -14.5rem -26.3rem;
            }
            &.geometry {
              background-position: -17.9rem -26.3rem;
            }
          }
          &.subj-ela {
            &.lr {
              background-position: -1.7rem -24.7rem;
            }
            &.db {
              background-position: -5.3rem -24.7rem;
            }
            &.rw {
              background-position: -8.8rem -25rem;
            }
            &.sw {
              background-position: -12.4rem -25rem;
            }
          }
        }
        &.grade-3 {
          &.subj-math {
            &.place-value-ns {
              background-position: -0.9rem -33.7rem;
            }
            &.add-sub-pv-3 {
              background-position: -4.3rem -33.7rem;
            }
            &.mult-div-facts {
              background-position: -7.7rem -33.7rem;
            }
            &.fractions {
              background-position: -11.2rem -33.7rem;
            }
            &.time-money {
              background-position: -14.5rem -33.7rem;
            }
            &.measurement-data {
              background-position: -17.9rem -33.7rem;
            }
            &.geometry {
              background-position: -21.6rem -33.7rem;
            }
            &.mult-div-pv-2 {
              background-position: -24.9rem -33.7rem;
            }
          }
        }
        &.grade-4 {
          &.subj-math {
            &.place-value-ns {
              background-position: -0.9rem -41.2rem;
            }
            &.algebra {
              background-position: -4.3rem -41.2rem;
            }
            &.add-sub-pv-4 {
              background-position: -7.7rem -41.2rem;
            }
            &.mult-div-pv {
              background-position: -11.1rem -41.2rem;
            }
            &.fractions {
              background-position: -14.5rem -41.2rem;
            }
            &.decimals {
              background-position: -17.9rem -41.2rem;
            }
            &.measurement-data {
              background-position: -21.6rem -41.2rem;
            }
            &.geometry {
              background-position: -25.0rem -41.2rem;
            }
          }
        }
        &.grade-5 {
          &.subj-math {
            &.decimals {
              background-position: -0.9rem -48.2rem;
            }
            &.algebra {
              background-position: -4.3rem -48.2rem;
            }
            &.mult-div-pv {
              background-position: -7.7rem -48.3rem;
            }
            &.fractions {
              background-position: -11.1rem -48.1rem;
            }
            &.decimal-arith {
              background-position: -14.7rem -48.2rem;
            }
            &.measurement-data {
              background-position: -17.9rem -48.2rem;
            }
            &.geometry {
              background-position: -21.3rem -48.2rem;
            }
          }
        }
      `;
    }
  }}
  background-size: ${props => props.subject === 'ela' ? 367 : 290}px;
  background-position: 0 0;
  background-repeat: no-repeat;
  width: 2.8rem;
  height: 2.8rem;
  align-self: flex-end;
  @media ${device.TabletLandscape}{
    transform: scale(1.6);
    margin: 0.5rem;
  }
  @media ${device.Tablet}{
    transform: scale(1.5);
    margin: 0.5rem;
  }
  @media ${device.PhoneTabletLandscape}{
    transform: unset;
    margin: unset;
    flex-basis: ${props => props.buildLearningPath ? '34%' : '20%'};
    order: ${props => props.buildLearningPath ? 1 : 2};
    align-self: ${props => props.buildLearningPath ? 'flex-end' : 'auto'};
  }
  @media ${device.PhonePortrait}{
    transform: scale(1.4);
  }
`;